import React from 'react';
import { Box, Container, Grid, Link, Stack, Typography } from '@mui/material';
import { Email as EmailIcon, LinkedIn as LinkedInIcon } from '@mui/icons-material';

const LandingFooter = () => (
  <Box
    sx={{
      py: 6,
      background: 'linear-gradient(135deg, #d0e8f8 0%, #b8d8f0 100%)',
      position: 'relative',
      zIndex: 1,
      borderTop: '1px solid rgba(25,118,210,0.12)'
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: '#1976d2' }}>
            Weaver AI
          </Typography>
          <Typography variant="body2" sx={{ color: '#333', mb: 3, maxWidth: 400 }}>
            The document intelligence platform that gets smarter with every extraction.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: '#1976d2' }}>
            Contact Us
          </Typography>
          <Stack spacing={2}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <EmailIcon sx={{ color: '#1976d2' }} />
              <Link
                href="mailto:assaf@weaversot.io"
                sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: '#1976d2' } }}
              >
                assaf@weaversot.io
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <LinkedInIcon sx={{ color: '#1976d2' }} />
              <Link
                href="https://il.linkedin.com/company/weaversoft-io"
                target="_blank"
                sx={{ color: '#333', textDecoration: 'none', '&:hover': { color: '#1976d2' } }}
              >
                linkedin.com/company/weaversoft-io
              </Link>
            </Box>
          </Stack>
        </Grid>
      </Grid>
      <Box sx={{ mt: 4, pt: 3, borderTop: 1, borderColor: 'rgba(25, 118, 210, 0.3)', textAlign: 'center' }}>
        <Typography variant="body2" sx={{ color: '#666' }}>
          © 2025 Weaver AI. All rights reserved.
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default LandingFooter;
